export const YES = "81C0A4CC-543E-4A79-8E8E-19AE5EADCBA3";
export const NO = "5BA097FF-D907-473A-88DC-5989A2C79C9D";
export const TRUE = "D78BE06B-F299-44BF-99EC-5F9329042C3B";
export const NO_SAVING = "D5FF35AE-8A31-4C38-8493-320F07B2A792";
export const NO_DEGREE = "0078C868-582A-46AC-9B7F-053C4D4A439D";
